import { UnorderedList } from 'atoms'

export const CollapsibleContentWhyPrivate = () => (
  <>
    <p>
      {`Ich habe Zeit für Sie und höre Ihnen zu. Wir gehen alle Schritte gemeinsam, nach Ihren Wünschen und Bedürfnissen, in Ihrem Tempo. Sie haben in der Regel keine Wartezeiten und treffen auf eine motivierte Therapeutin/Beraterin mit Methodenvielfalt und Lebenserfahrung. Mein Büro ist zentral erreichbar und bietet Ihnen einen Rückzugsraum in angenehmer Atmosphäre. Die Nutzung meines Angebots wird nicht "aktenkundig" und birgt so keine Nachteile für eventuelle Versicherungseinstufungen oder ähnliches.`}
    </p>

    <UnorderedList items={[
      'Termin sofort',
      'Keine Dokumentation in der Krankenakte',
      'Motivierte Therapeutin',
      'Methodenvielfalt',
      'Praxis zentral erreichbar',
    ]} type="check" />
  </>
)

export const CollapsibleContentMyWorkflow = () => (
  <>
    <p>
      {`Systemische Gesprächstherapie mit hypnosystemischen Elementen, individuell und lösungsorientiert, bedarfsorientiert, ganzheitlich und nachhaltig.`}
    </p>
    <p>
      {`Als Systemikerin schaue ich in besonderer Weise auf Muster und Zusammenhänge des Verhaltens von Menschen in Gruppen. Zu den Grundannahmen systemischer Betrachtung gehört, das Verhalten immer kontextabhängig ist und Symptome Lösungsversuche darstellen. Wichtige Fragen sind: Wie könnte man es noch sehen? Und welche Sichtweise ist dienlicher? Mein Hauptanliegen ist es, Sie dabei zu unterstützen Ihren individuellen Möglichkeitsraum zu vergrößern. Dabei bewerte ich sie nicht, sondern spiegel Ihr Verhalten, um Ihnen Selbsterkenntnis zu ermöglichen. Als theoretische Grundlagen dienen mir über die Systemik hinaus Erkenntnisse der Tiefenpsychologie und der Verhaltenpsychologie. Weiterhin arbeite ich mit hypnosystemischen Elementenund lasse neueste Erkenntnisse der Hirnforschung in meine Arbeit einfließen. Während unserer Gespräche werden wir auch immer wieder gemeinsam ins Tun kommen.`}
    </p>
    <p>
      <strong>
        Mein Motto: Wer es anders haben möchte, muss es anders machen.
      </strong>
    </p>
  </>
)

export const CollapsibleContentSecurity = () => (
  <>
    <p>
      {`Das erste Gespräch dient dem gemeinsamen Kennenlernen und ist für Sie kostenfrei. Damit Sie Ihre Entscheidung in Sicherheit und in Ruhe treffen können. Ich bin an Ihrer Seite bei Veränderungsprozessen und in akuten Krisenzeiten. Ich bin gern für Sie da, nehmen Sie Kontakt zu mir auf.`}
    </p>
  </>
)

export const CollapsibleContentPossibleTopics = () => (
  <>
    <UnorderedList items={[
      'Allgemeine psychische Probleme',
      'Lebensberatung/Beziehungsberatung',
      'Stress, Burnout, Mobbing',
      'Ängste, Zwänge, Phobien',
      'Anpassungsstörungen (akute und posttraumatische)',
      'Dissoziative und somatoforme Störungen',
      'Trauer',
    ]} />
  </>
)
